const options = {
  5: "bg-gray-300/5",
  10: "bg-gray-300/10",
  25: "bg-gray-300/25",
  50: "bg-gray-300/50",
  75: "bg-gray-300/75",
  90: "bg-gray-300/90",
  100: "bg-gray-300",
};

const from = {
  5: "from-gray-300/5",
  10: "from-gray-300/10",
  25: "from-gray-300/25",
  50: "from-gray-300/50",
  75: "from-gray-300/75",
  90: "from-gray-300/90",
  100: "from-gray-300",
};

export default function getBackgroundGray300(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
